document.addEventListener('DOMContentLoaded', () => {
  function updateInstagramLinks() {
    const container = document.querySelector('.instafeed-new-layout-container');
    if (!container) return;

    const links = container.querySelectorAll('a[target="_blank"]');
    links.forEach((link, index) => {
      if (!link.hasAttribute('aria-label')) {
        link.setAttribute('aria-label', `Instagram post ${index + 1} (opens in a new tab)`);
      }
    });
  }

  // Use MutationObserver on the whole body to catch dynamic loads
  const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        // If the instafeed container or new children are added
        if (node.nodeType === 1) { // nodeType 1 = Element
          if (node.matches('.instafeed-new-layout-container') || node.querySelector('.instafeed-new-layout-container')) {
            updateInstagramLinks();
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Just in case it’s already loaded when the page loads
  updateInstagramLinks();
});


(function () {
  // Utility to wait for an element
  function waitForElement(selector, callback, timeout = 10000) {
    const start = performance.now();
    function check() {
      const el = document.querySelector(selector);
      if (el) callback(el);
      else if (performance.now() - start < timeout) requestAnimationFrame(check);
    }
    check();
  }

  // 1. Make gift wrap LTD checkbox keyboard-accessible and simulate click to open modal
  waitForElement('.ldt-gw-gift-option-checkbox', (checkboxLabel) => {
    checkboxLabel.setAttribute('tabindex', '0');
    checkboxLabel.setAttribute('role', 'checkbox');

    const input = checkboxLabel.querySelector('input[type="checkbox"]');

    const updateAria = () => checkboxLabel.setAttribute('aria-checked', input.checked);
    updateAria();

    checkboxLabel.addEventListener('keydown', (e) => {
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        checkboxLabel.click(); // simulate full click, triggers modal
      }
    });

    input.addEventListener('change', updateAria);
  });

  // 2. When modal appears, move focus and enhance dropdown
  const modalObserver = new MutationObserver(() => {
    const modal = document.querySelector('.lgw-Modal__InnerContent');
    if (modal && !modal.hasAttribute('tabindex')) {
      modal.setAttribute('tabindex', '-1');
      modal.focus({ preventScroll: true });

      // 3. Wait for dropdown label inside modal
      waitForElement('.ldt-gw-select-label', (label) => {
        label.setAttribute('tabindex', '0');
        label.setAttribute('role', 'button');
        label.setAttribute('aria-expanded', 'false');

        label.addEventListener('keydown', (e) => {
          if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            label.click(); // open dropdown
          }
        });

        // 4. Watch for dropdown list to be added after click
        const optionsObserver = new MutationObserver(() => {
          const listbox = document.querySelector('.ldt-gw-select-options');
          if (listbox) {
            listbox.setAttribute('role', 'listbox');

            const options = listbox.querySelectorAll('li');
            options.forEach((opt, i) => {
              opt.setAttribute('tabindex', '0');
              opt.setAttribute('role', 'option');

              opt.addEventListener('keydown', (e) => {
                if (e.key === 'ArrowDown') {
                  e.preventDefault();
                  const next = options[i + 1];
                  if (next) next.focus();
                } else if (e.key === 'ArrowUp') {
                  e.preventDefault();
                  const prev = options[i - 1];
                  if (prev) prev.focus();
                } else if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  opt.click();
                }
              });
            });
          }
        });

        optionsObserver.observe(modal, { childList: true, subtree: true });
      });
    }
  });

  modalObserver.observe(document.body, { childList: true, subtree: true });
})();

document.querySelector('[data-spec="toggle-button"]').addEventListener('click', function () {
  const MAX_RETRIES = 20;
  let attempts = 0;

  const tryFocusChat = () => {
    const chatComponent = document.querySelector('inbox-online-store-chat');
    if (!chatComponent || !chatComponent.shadowRoot) {
      retry();
      return;
    }

    const input = chatComponent.shadowRoot.querySelector('[data-spec="message-input"]');

    if (input && isVisible(input)) {
      // Set tabindex temporarily and force focus
      input.setAttribute('tabindex', '-1');
      input.focus({ preventScroll: true });

      // Optional: force screen reader announcement
      input.setAttribute('aria-live', 'polite');
      input.setAttribute('aria-label', input.getAttribute('aria-label') || 'Chat input');
    } else {
      retry();
    }
  };

  const retry = () => {
    attempts++;
    if (attempts < MAX_RETRIES) {
      setTimeout(tryFocusChat, 150);
    }
  };

  const isVisible = (el) => {
    const style = window.getComputedStyle(el);
    return style && style.display !== 'none' && style.visibility !== 'hidden' && el.offsetParent !== null;
  };

  tryFocusChat();
});
